module.exports = __webpack_public_path__ + "img/culture4Hover.05ebc088.jpg";